import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import { useEffect, useState } from "react";
import { getPractice } from "../../api";
import { getPlacesOfService } from "../../afinanceapi";
import { jwtDecode } from "jwt-decode";
import { getUsers } from "../../api";
import { EditPractice } from "./EditPractice";
import { AddPracticeLogo } from "./AddPracticeLogo";
import React from "react";

export function ViewPractice({ refresh, onPracticeUpdate = () => {} }) {
  const [practices, setPractices] = useState([]);
  const [selectedPractice, setSelectedPractice] = useState(null);
  const [modalShow, setModalShow] = useState(false);
  const [selectedPracticeId, setSelectedPracticeId] = useState(null);
  const [logoModalShow, setLogoModalShow] = useState(false);
  const [selectedPracticeURL, setSelectedPracticeURL] = useState(null);
  const [placesOfService, setPlacesOfService] = useState([]);

  useEffect(() => {
    let cancelled = false;
    getPlacesOfService()
      .then((data) => {
        if (cancelled) return;
        setPlacesOfService(Array.isArray(data) ? data : []);
      })
      .catch(() => { if (!cancelled) setPlacesOfService([]); });
    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    async function getPractices() {
      const token = sessionStorage.getItem("user");
      if (token) {
        const decoded = jwtDecode(token);
        const allPrac = await getPractice();
        const allUsers = await getUsers();
        const findUser = allUsers.find((user) => user._id === decoded._id);

        // Filter practices and sort them
        const filteredPrac = allPrac.filter((prac) =>
          findUser.practice.includes(prac.practiceNumber)
        );

        // Sort practices: holdingPractice first, then alphabetically by practiceName
        const sortedPractices = filteredPrac.sort((a, b) => {
          if (a.holdingPractice === "true" && b.holdingPractice !== "true")
            return -1;
          if (a.holdingPractice !== "true" && b.holdingPractice === "true")
            return 1;
          return a.practiceName.localeCompare(b.practiceName);
        });

        setPractices(sortedPractices);
      }
    }
    getPractices();
  }, [refresh]);

  const handleEditClick = (practiceNumber) => {
    setSelectedPractice(practiceNumber); // Set the practice to be edited
    setModalShow(true); // Show the modal
  };

  const handleLogoClick = (practiceId, practiceLogoURL) => {
    setSelectedPracticeId(practiceId); // Set the practice to be edited
    setSelectedPracticeURL(practiceLogoURL);
    setLogoModalShow(true); // Show the modal
  };

 return (
  <div className="bg-transparent">
    {practices.map((practice) => (
      <Row className="g-0" key={practice.practiceNumber}>
        <Col xs={12}>
          <Container className="container pt-3 bg-white shadow-sm pb-3 mb-1 position-relative">
            {/* Top-Right Badges and Edit Button */}
            <div className="position-absolute top-0 end-0 mt-2 me-3 d-flex align-items-center">
              <span
                className={`badge me-1 ${
                  practice.holdingPractice === "true" ? "bg-primary text-white" : ""
                }`}
              >
                {practice.holdingPractice === "true" ? "Main" : ""}
              </span>
              <span
                className={`badge me-1 ${
                  practice.practiceType === "Medical" ? "bg-secondary" : "bg-primary"
                }`}
              >
                {practice.practiceType === "Medical" ? "Medical" : "Non-Medical"}
              </span>
              <Button
                variant=""
                onClick={() => handleEditClick(practice.practiceNumber)}
              >
                <i className="fas fa-edit text-primary"></i>
              </Button>
            </div>

            {/* Row containing Logo + Practice Info */}
            <Row className="align-items-start">
              {/* Logo Section - Top Left */}
              <Col xs="auto" className="d-flex flex-column align-items-start">
                <div className="position-relative">
                  <img
                    src={
                      practice.logoURL ||
                      "https://practostorage.blob.core.windows.net/practotest/logo-placeholder-image.png?sp=r&st=2025-02-14T06:32:12Z&se=2025-02-14T14:32:12Z&spr=https&sv=2022-11-02&sr=b&sig=MFFyJLok0cf0Gzy60IkhlmnFLo5ItUHBcI86lL%2F%2BU5I%3D"
                    }
                    alt="Practice Logo"
                    height={80}
                  />
                  <Button
                    variant=""
                    className="position-absolute pt-4 ps-2"
                    onClick={() => handleLogoClick(practice._id, practice.logoURL)}
                  >
                    <i className="fas fa-edit text-primary"></i>
                  </Button>
                </div>
              </Col>

              {/* Practice Name + Number + VAT aligned to top right of logo */}
              <Col className="d-flex flex-column justify-content-start">
                <p className="fw-bold text-primary mb-0">
                  {practice.practiceName}
                </p>
                <p className="ms-4 mb-0 text-muted">
                  Practice#: {practice.practiceNumber}
                </p>
                {practice.hpcsaNumber && (
                  <p className="ms-4 mb-0 text-muted">HPSCA: {practice.hpcsaNumber}</p>
                )}
                {practice.VATNumber && (
                  <p className="ms-4 mb-0 text-muted">VAT#: {practice.vatNumber}</p>
                )}
                <p className="ms-4 mb-1 text-muted">{practice.practiceCare}</p>
              </Col>
            </Row>

            {/* Locations grid (full width) */}
            {(() => {
              const locations =
                Array.isArray(practice.locations) && practice.locations.length
                  ? practice.locations
                  : [
                      {
                        name: practice.primaryLocationName || "Main Location",
                        address1: practice.practiceAddress || "",
                        address2: practice.practiceAddress2 || "",
                        city: practice.practiceCity || "",
                        province: practice.practiceProvince || "",
                        postalCode: practice.practicePostalCode || "",
                        placeOfService: practice.practicePlaceOfService || "",
                      },
                    ];

              return (
                <Row className="mt-2 gx-3">
                  {locations.map((loc, idx) => {
                    // For the primary slot (idx 0) fall back to the top-level
                    // practicePlaceOfService — older docs may have the POS only
                    // at the practice level, not yet mirrored into locations[0].
                    const posCode =
                      loc.placeOfService ||
                      (idx === 0 ? practice.practicePlaceOfService : "") ||
                      "";
                    const posMatch = posCode
                      ? placesOfService.find((p) => p.HCFA_code === posCode)
                      : null;
                    return (
                      <Col
                        key={`${loc.name || "loc"}-${idx}`}
                        xs={12}
                        sm={6}
                        md={3}
                        className="mb-2"
                      >
                        <div
                          className="mb-1 fw-semibold text-primary text-truncate"
                          title={loc.name}
                        >
                          <i className="fas fa-location-dot me-2 text-primary" />
                          {loc.name || "Location"}
                        </div>
                        <div className="text-muted small text-wrap">
                          {loc.address1 && <div>{loc.address1}</div>}
                          {loc.address2 && <div>{loc.address2}</div>}
                          {(loc.city || loc.province || loc.postalCode) && (
                            <div>
                              {loc.city}
                              {loc.city && loc.province ? ", " : ""}
                              {loc.province} {loc.postalCode}
                            </div>
                          )}
                          {posCode && (
                            <div>
                              POS: {posCode}
                              {posMatch ? ` - ${posMatch.newDescription}` : ""}
                            </div>
                          )}
                        </div>
                      </Col>
                    );
                  })}
                </Row>
              );
            })()}

            {/* Contact row (single, full width) */}
            <Row className="mt-2">
              <Col xs={12}>
                <p className="mb-1">
                  <i className="fas fa-phone-alt me-2 text-primary"></i>
                  {practice.practicePhoneNumber}
                </p>
                <p className="mb-1">
                  <i className="fas fa-envelope me-2 text-primary"></i>
                  {practice.practiceEmail}
                </p>
                {practice.practiceWebsite && (
                  <p className="mb-1">
                    <i className="fas fa-globe me-2 text-primary"></i>
                    {practice.practiceWebsite}
                  </p>
                )}
              </Col>
            </Row>
          </Container>
        </Col>
      </Row>
    ))}

    {modalShow && (
      <EditPractice
        show={modalShow}
        onHide={() => setModalShow(false)}
        practiceNum={selectedPractice}
        onPracticeUpdate={onPracticeUpdate}
      />
    )}
    {logoModalShow && (
      <AddPracticeLogo
        show={logoModalShow}
        onHide={() => setLogoModalShow(false)}
        practiceId={selectedPracticeId}
        practiceLogoURL={selectedPracticeURL}
        onLogoUpdate={onPracticeUpdate}
      />
    )}
  </div>
);
}
